import { useFlags } from 'launchdarkly-react-client-sdk';

type CopilotFeatureFlags = {
    isNewCommStyleSmartReplyEnabled: boolean;
    isCampaignSetupV2Enabled: boolean;
    isUnrepliedTabDismissButtonEnabled: boolean;
    isRichTextEditorEnabled: boolean;
    isNewCampaignCreationEndpointEnabled: boolean;
    isNewCampaignEditEnabled: boolean;
    isNewCampaignMessagingEnabled: boolean;
    isAiMessageEditEnabled: boolean;
    isReplyRecommendationsEnabled: boolean;
    isAiMessageSequenceGenEnabled: boolean;
    isAutoReplyBetaV1Enabled: boolean;
};

/**
 * Hook to get the feature flags
 * @returns an object with the feature flags
 */
export function useFeatureFlags() {
    const flags = useFlags<CopilotFeatureFlags>();

    return {
        ...flags,
    };
}
